import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Container,
  IconButton,
} from "@mui/material";

import { Request_Letter } from "./api/Request_Letter";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import GetClientAddress from "../../../../functions/GetClientAddress";
import LetterTable from "./components/LetterTable";
import { Request_Get_Registers_Fuzzy_Search } from "../../Registers/api/Request_Get_Registers_Fuzzy_Search";
import SearchSetRegisters from "../../../components/Search/SearchSetRegisters";

const SummerLetters = () => {
  const { logout } = StaffuseAuth();

  //----------------------------------------------------------
  const [Arr_Bookings, setArr_Bookings] = useState([]);
  useEffect(() => {
    Request_Get_Registers_Fuzzy_Search(
      "Registers_2025",
      "All",
      {},
      50,
      setArr_Bookings,
      logout
    );
  }, []);

  //filter out weekends and anyone with Archived value of "Yes"
  let Arr_Bookings_Filtered = Arr_Bookings.filter(
    (obj_booking) =>
      !obj_booking.BasicInfo?.ProgrammeTitle.toLowerCase().includes(
        "weekend"
      ) && obj_booking.MetaData?.Archived !== "Yes"
  );

  return (
    <div style={{ marginLeft: "10px", marginRight: "10px" }}>
      <style jsx>{`
        #BookingTable {
          font-family: Arial, Helvetica, sans-serif;
          border-collapse: collapse;
          width: 100%;
        }

        #BookingTable td,
        #BookingTable th {
          border: 1px solid #ddd;
          padding: 8px;
        }

        #BookingTable tr:nth-child(even) {
          background-color: #ffffff;
        }

        #BookingTable tr:hover {
          background-color: #ddd;
        }

        #BookingTable th {
          padding-top: 12px;
          padding-bottom: 12px;
          background-color: #04aa6d;
          color: white;
        }
      `}</style>

      {/* <!-- Bookings --> */}
      <div
        className="w3-row-padding w3-padding-64 w3-theme-l5 w3-center"
        id="Bookings"
        style={{ position: "relative", minHeight: "100vh" }}
      >
        <br></br>
        <div style={{ width: "100%", display: "flex" }}>
          <SearchSetRegisters setRegisters={setArr_Bookings} />
        </div>
        <h1>Get VISA and Acceptance Letters</h1>
        <LetterTable Arr_Bookings={Arr_Bookings_Filtered} />
      </div>
    </div>
  );
};

export default SummerLetters;
